module.exports = __webpack_public_path__ + "static/media/web_tool.04c0bf1a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/homepage/icons/web_tool.svg
// module id = 1151
// module chunks = 0